<div class="main-column scroll-block">
    <login-header-component></login-header-component>
    <router-outlet></router-outlet>
    <login-footer-component></login-footer-component>
</div>
